import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import type { AppDispatch, RootState } from '../redux/store';
import { fetchPhotos } from '../redux/thunks/imageThunks';
import Sidebar from './Sidebar';
import Header from './Header';
import NavbarApp from './navbarApp';
import { ImageIcon } from 'lucide-react';

const AlbumDashboard: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { albumId, albumName, createdBy } = useParams<{ albumId: string; albumName: string; createdBy: string }>();
  const imagesState = useSelector((state: RootState) => state.images);
  const authState = useSelector((state: RootState) => state.auth);

  const user = authState.user;
  const photos = imagesState.photos || [];

  // console.log(imagesState)
  const [sidebarOpen, setSidebarOpen] = useState(false);

//   console.log(albumId)
  useEffect(() => {
    if (albumId && imagesState.status === 'idle') {
      dispatch(fetchPhotos(albumId));
    }
  }, [dispatch, albumId, imagesState.status]);


  if (authState.loading || imagesState.status === 'loading') {
    return <p className="text-center mt-10 text-gray-500">Loading...</p>;
  }

  if (authState.error || imagesState.status === 'failed') {
    return (
      <p className="text-center mt-10 text-red-500">
        Error: {imagesState.errorMessage || ''} {authState.error || ''}
      </p>
    );
  }

  return (
    <div className="min-h-screen text-white bg-black flex flex-col">
      <NavbarApp user={user} setSidebarOpen={setSidebarOpen}/>

      {/* Mobile Sidebar overlay */}
      <div
        className={`fixed inset-0 z-40 md:hidden transition-transform duration-300 ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div
          className="absolute inset-0 bg-black bg-opacity-50"
          onClick={() => setSidebarOpen(false)}
        />
        <div className="relative w-64 bg-gray-900 h-full">
          <Sidebar />
        </div>
      </div>

      {/* Content below navbar */}
      <div className="flex flex-1">
        <div className="hidden md:block w-64 bg-gray-900">
          <Sidebar />
        </div>

        <div className="flex-1 overflow-y-auto">
          <div className="px-4 sm:px-8 py-6">
            <h2 className="text-2xl font-bold mb-6">Album: {albumName}</h2>
            {photos.length === 0 ? (
              <div className="flex flex-col items-center justify-center text-white mt-10 space-y-4">
                <ImageIcon className="w-12 h-12 text-white" />
                {createdBy === user?.id ? (
                  <>
                    <p className="text-white text-lg font-medium">
                      You haven't added any images to this album yet.
                    </p>
                    <button
                      onClick={() => navigate('/upload-images')}
                      className="px-5 py-2 bg-white hover:bg-gray-100 text-black rounded-lg shadow-md transition duration-300 font-semibold"
                    >
                      Add Photos
                    </button>
                  </>
                ) : (
                  <p className="text-white text-base italic">
                    This album has no images yet. Please check back later.
                  </p>
                )} 
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6">
                {photos.map((photo, index) => {
                  // console.log(typeof photo);
                  return(
                  <div
                    key={index}
                    className="bg-gray-800 rounded-lg overflow-hidden shadow-md"
                  >
                    <img
                      src={photo}
                      alt={''}
                      className="w-full h-48 object-cover"
                    />
                  </div>
                )})}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlbumDashboard;
